// Sample Object for three level filter. First level is Make, second is model and third is year. Last/Third filter should be an array.
// First value is Make, second is model and this is year
let makeObject = {
  Ford: {
    Bronco: ["2025", "2024", "2023", "2022", "2021"],
    "F-150": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
    "F-250": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    "F-350": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017"],
    Ranger: ["2025", "2024", "2023", "2022", "2021", "2020", "2019"],
    Maverick: ["2025", "2024", "2023", "2022"]
  },

  Jeep: {
    "Wrangler JL": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018"],
    "Gladiator JT": ["2025", "2024", "2023", "2022", "2021", "2020"],
    "Grand Cherokee": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011"]
  },

  Toyota: {
    Tacoma: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"],
    Tundra: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    "4Runner": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010"],
    "FJ Cruiser": ["2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007"]
  },

  Chevrolet: {
    "Silverado 1500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Colorado: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"],
  },

  GMC: {
    "Sierra 1500": ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014"],
    Canyon: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015"]
  },

  Nissan: {
    Frontier: ["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016", "2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"],
    Xterra: ["2015", "2014", "2013", "2012", "2011", "2010", "2009", "2008", "2007", "2006", "2005"]
  }
};

// Sample Object for two level filter. This sample data has filters for Car Make and Car Model. Last/Second filter should be an array.
let makeObject2 = {
  Acura: ["2015", "2014", "2013"],
  Accelera: ["175-70r13", "175-70r14", "175-70r15"],
  Nitto: ["165-60r13", "165-60r14", "165-60r15"],
};

// Sample Object for four level filter. This sample data has filters for Wheel Brand, Wheel Size, Lug Count, and Bolt Pattern. Last/Fourth filter should be an array.
let makeObject3 = {
  Acura: {
    ILX: {
      2014: ["4x100", "4x108"],
      2015: ["5x112", "5x114.3"],
    },
    Integra: {
      2015: ["5x100", "5x114.3", "5x120"],
    },
  },
  Enkei: {
    "17x8": {
      4: ["4x100", "4x108"],
      5: ["5x112", "5x114.3"],
    },
    "18x8.5": {
      5: ["5x100", "5x114.3", "5x120"],
    },
  },
  BBS: {
    "18x9": {
      5: ["5x112", "5x120"],
    },
    "19x8.5": {
      5: ["5x112", "5x114.3"],
    },
  },
  "OZ Racing": {
    "17x7.5": {
      4: ["4x100", "4x108"],
      5: ["5x100", "5x114.3"],
    },
    "18x8": {
      5: ["5x112", "5x120"],
    },
  },
  Forgestar: {
    "18x9": {
      5: ["5x114.3", "5x120"],
    },
    "19x10": {
      5: ["5x112", "5x120"],
    },
  },
  Vossen: {
    "20x9": {
      5: ["5x112", "5x120"],
    },
    "20x10.5": {
      5: ["5x114.3", "5x120"],
    },
  },
};
